import _ from 'lodash';
import Cookies from 'js-cookie';
import i18n from '../i18n';

/**
 * Group of utility functions used in multiple locations within the app.
 */

/* Lodash Utils */
export const get = _.get;
export const set = _.set;
export const setWith = _.setWith;
export const uniqBy = _.uniqBy;
export const makeSlug = (value) => {
  const input = value || '';
  return _.kebabCase(input.toLowerCase().replace('.', ''));
};
export const isEmpty = _.isEmpty;
export const zip = _.zip;
export const flatten = _.flatten;
export const cloneDeep = _.cloneDeep;
export const values = _.values;
export const merge = _.merge;

/**
 * Cookie Utils
 * Currently only used to retrieve a pre-existing
 * ZipCode cookie
 */
export const getCookie = Cookies.get;
export const setCookie = Cookies.set;

/**
 * i18n Util
 * Used to retrieve strings from within the i18n file for the brand
 */
export const geti18n = term => get(i18n, term);

/**
 * Currency Util
 *  Util for formatting values to display as currency
 */
export const formatCurrency = (value) => {
  if (isNaN(value)) {
    return value;
  }
  return `$${parseInt(value, 10).toLocaleString()}`;
};

/**
 * Zip Code Util
 * Used to determine if a zip code is valid
 * @param value - the Zip code from the user or the cookie
 * @returns {boolean}
 */
export const isValidZip = (value) => {
  if (!value) return false;
  const re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  return re.test(value);
}

// I dont love this function but it's working right now.
export const trademarkFriendlyString = (value) => {
  const sanatizedString = value
    .replace(/&reg;/g, '®')
    .replace(/<\/?[^>]+(>|$)/g, '');
  return sanatizedString;
}

export function isYupValidationError(error) {
  return get(error, 'name') === 'ValidationError' && error.isYupError;
}



/** WEBPACK FOOTER **
 ** ./src/utils/index.js
 **/